/* 微信页面内分享 */

/*
**  shareData: {
**      title: '',
**      desc: '',
**      link: '',
**      imgUrl: ''
**  };
*/

function ShareWechat(shareData) {
    var jsSdkApi = '//res.wx.qq.com/open/js/jweixin-1.6.0.js';
    var signWechatUrl = "//live.sohu.com/share/wechat/share/info";
    var isWeixin = function() {
        var ua = navigator.userAgent.toLowerCase();
        return (/micromessenger/.test(ua)) ? true : false;
    };
    var loadJsSdk = function(url, callback) {
        var head = document.getElementsByTagName('head')[0];
        var js = document.createElement('script');
        js.setAttribute('type', 'text/javascript');
        js.setAttribute('src', url);
        head.appendChild(js);
        js.onload = callback;
    };

    var handleShareCon = function(data) {
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
            openTagList: ['wx-open-launch-weapp']

        });

        wx.ready(function() {
            wx.onMenuShareAppMessage(shareData);
            wx.onMenuShareTimeline(shareData);
        });
    };

    var init = function() {

        $.ajax({
            type: 'GET',
            url: signWechatUrl,
            data: {
                url: location.href
            },
            dataType: 'json',
            success: function(rs) {
                handleShareCon(rs);
            }
        });
    };

    if (isWeixin()) {
        loadJsSdk(jsSdkApi, init);
    }
}

export default ShareWechat;